module.exports = __webpack_public_path__ + "static/media/Engagement_Party.fff59851.png";